import React from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Loading } from 'konsys-ui'
import { GET_TYPE_OF_CHARGES } from '../../../constants/graphql/query'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/client-components'

export default {
  columns: [{
    Header: () => <HeaderLabel>ชื่อบริษัท</HeaderLabel>,
    accessor: 'companyName',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: false,
    filterable: true,
    width: 300,
  }, {
    Header: () => <HeaderLabel>สาขา</HeaderLabel>,
    accessor: 'branch',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.companyId, filter.value),
    width: 110,
  }, {
    Header: <HeaderLabel>เบอร์โทรศัพท์</HeaderLabel>,
    accessor: 'contactNumber',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>อีเมล</HeaderLabel>,
    accessor: 'email',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 160,
  }, {
    Header: <HeaderLabel>ประเภท</HeaderLabel>,
    accessor: 'TypeOfCharge.id',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.original.TypeOfCharge.name}</CellText>,
    Filter: ({ onChange }) => <Query
      query={GET_TYPE_OF_CHARGES}
    >
     { ({ error, loading, data }) => {
       if (error) return <p>เกิดข้อผิดพลาด</p>
       if (loading && _.isEmpty(data)) return <Loading center/>
       let newArr = [{ value: 'ALL', text: 'ทั้งหมด' }]
       newArr = _.concat(newArr, data.getTypeOfChargeList.lists.map(v => (
         { value: v.id, text: v.name }
       )))
       return (
          <DropdownSelector
            key='filter'
            data={newArr}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
          />
       )
     }}
    </Query>,
    filterMethod: (filter, row) => _.includes(row.Customer.typeOfCharge, filter.value),
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    // Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} />,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
